import type EnType from '../en-US/common';

export default {
  colon: ':',
  export: 'Exportar',
  delete: 'Eliminar',
  view: 'Ver',
  send: 'Enviar',
  sending: 'Enviando',
  search: 'Buscar',
  find: 'Buscar',
  save: 'Guardar',
  saveAndExit: 'Guardar y Salir',
  saved: 'Guardado',
  cancel: 'Cancelar',
  close: 'Cerrar',
  dismiss: 'Descartar',
  name: 'Nombre',
  value: 'Valor',
  description: 'Descripción',
  updatedIn: 'Última modificación:',
  defaultFolder: 'Carpeta Raíz',
  codeGenerate: 'Generar Código',
  responsible: 'Mantenedor',
  format: 'Formato',
  moreHelp: 'Ayuda',
  copyToClipboard: 'Copiar al portapapeles',
  noContent: 'Sin Contenido',
  enumeratedValue: 'Enums',
  'message.requestException': 'Excepción de solicitud',
  'message.requestError': 'Excepción de solicitud',
  'message.exportSuccess': 'Exportación Exitosa.',
  'message.networkFailure': 'Error de Red, por favor verifica la red, o intenta más tarde',
  'message.serverFailure': 'Error del Servidor, por favor intenta más tarde',
  'button.text.reload': 'Recargar',
  'message.loadError.checkNetwork': 'Error de carga, por favor verifica si la red está caída',
  'message.scriptError.checkNetworkOrContactStaff':
    "Ocurrió un error anormal, por favor intenta 'Recargar' o 'Obtener Soporte' para ayudarte a solucionarlo!",
  more: 'Más',
  download: 'Descargar',
  downloadFileAndUnitSize: 'Descargar({unitSize})',
  viewAsText: 'Ver como texto',
  copyContent: 'Copiar Contenido',
  wrap: 'Ajustar',
  request: 'Solicitud',
  response: 'Respuesta',
  'request.example.title.right': 'Solicitud',
  'request.example.title.center': ' Ejemplo de Solicitud',
  'response.example.title.right': 'Respuesta',
  'response.example.title.center': ' Ejemplo de Respuesta',
  redirect: 'Redirigir',
  console: 'Consola',
  header: 'Encabezados',
  cookie: 'Cookies',
  selectCharset: 'Seleccionar Charset',
  isCopied: 'Copiado',
  failToCopied: 'Error al copiar, por favor registra manualmente el siguiente contenido',
  'runner.tryItOut': 'Pruébalo',
  'runner.selectCase': 'Seleccionar Caso',
  tryItOut: 'Pruébalo',
  runInApp: 'Ejecutar en {appName}',
  clone: 'Clonar',
  'customDomain.cname.alibaba': 'El dominio es ICP Alibaba Cloud',
  'customDomain.cname.otherCloud': 'El dominio es ICP Tencent Cloud',
  'customDomain.cname.HK': 'Servidor de Hong Kong, un poco más lento',
  graphqlGetTips:
    "Al hacer una solicitud HTTP GET, la consulta GraphQL debe definirse en el campo 'query' de los Parámetros.",
  onlineShareHasBeenCopyToTeam:
    'Documentación de API clonada <strong>【{onlineShareName}】</strong> al equipo <strong>【{teamName}】</strong>',
  'onlineShare.export': 'Exportar Datos',
  'onlineShare.export.dataType': 'Formato de Datos',
  'exportData.export.openapi.version': 'Versión de Especificación OpenAPI',
  'exportData.export.openapi.version.31': 'OpenAPI 3.1',
  'exportData.export.openapi.version.30': 'OpenAPI 3.0',
  'exportData.export.openapi.version.20': 'Swagger 2.0',
  'exportData.export.openapi.includeExtension':
    'Incluyendo Campos OpenAPI de Extensión {appName} (x-{appNameLower}-***)',
  'exportData.export.openapi.includeExtension.no': 'No',
  'exportData.export.openapi.includeExtension.yes': 'Sí',
  'exportData.export.openapi.tags': 'Exportar carpeta como campo Tags',
  'exportData.export.openapi.tags.yes': 'Sí',
  'exportData.export.openapi.tags.no': 'No',
  'onlineShare.clone': 'Clonar a Mi {appName}',
  'onlineShare.notExisted': 'Esta documentación no existe o ha sido eliminada.',
  'onlineShare.noAccess': 'No tienes permiso para acceder a esta documentación',
  'onlineShare.expired.subTitle':
    'Por favor contacta al propietario de la documentación para obtener acceso.',
  'apidoc.unPublish': 'Esta documentación aún no está publicada',
  'apidoc.unPublish.subTitle':
    'Por favor contacta al editor de la documentación para publicar la documentación antes de acceder a la URL actual.',
  'onlineShare.needPassword': 'Esta documentación requiere una contraseña para acceder',
  'onlineShare.sendCodeSuccess':
    'Si tu correo está en la lista de permitidos, recibirás el código de verificación pronto.',
  'exportData.appDocumentation.json': 'apiDocumentation.{appNameLower}.json',
  'onlineShare.resource.notExisted.title': '404',
  'onlineShare.resource.notExisted.subTitle': `Página no encontrada`,
  'onlineShare.resource.notExisted.reload': 'Recargar',
  backToHome: 'Volver al inicio',
  home: 'Inicio',
  'email.auth.tip': 'Esta documentación requiere un código de verificación por correo para acceder',
  'customDomain.error.tip':
    'Configuración CNAME Inválida. Por favor verifica las reglas a continuación.',
  'customDomain.error.tip2': 'Configuración CNAME Inválida.',
  previous: 'Anterior',
  next: 'Siguiente',
  'message.noPrivilege': 'Permisos insuficientes',
  'onlineShare.expired': 'Esta documentación ha expirado.',
  'onlineShare.notShared': 'Esta documentación aún no está compartida',

  'docsSite.enableVibeCodingViaMCP.suffix': 'Especificación de API',
  'docsSite.enableVibeCodingViaMCP': 'MCP',
  'docsSite.enableVibeCodingViaMCP.tooltip':
    'Potencia tu experiencia de Vibe Coding habilitando herramientas de IA como Cursor y GitHub Copilot para acceder al sitio completo de documentación de API.',
  'docsSite.enableVibeCodingViaMCP.modal.title': 'MCP',
  'docsSite.enableVibeCodingViaMCP.modal.description':
    '## 🚀 Guía de Configuración\n\n### **Prerrequisitos**\n\n- **Node.js** (versión 18 o superior, preferiblemente la última versión LTS).\n- Un IDE que soporte MCP, como:\n  - **Cursor**\n  - **VS Code + plugin Cline**\n\n### Configurar el IDE\n\n- Copia el siguiente código de configuración JSON para agregar al archivo de configuración MCP en tu IDE:\n\n```json\n{\n  "mcpServers": {\n    "{serverName}": {\n      "command": "npx",\n      "args": [\n        "-y",\n        "{appNameLower}-mcp-server@latest",\n        "--site-id={docsSiteId}"\n      ]\n    }\n  }\n}\n```\n\nSi estás en **Windows** y el archivo de configuración anterior no funciona, intenta usar el archivo de configuración a continuación:\n\n```json\n{\n  "mcpServers": {\n    "{serverName}": {\n      "command": "cmd",\n      "args": [\n        "/c",\n        "npx",\n        "-y",\n        "{appNameLower}-mcp-server@latest",\n        "--site-id={docsSiteId}"\n      ]\n    }\n  }\n}\n```\n\n## 🎯 ¿Cómo Funciona el Servidor MCP de {appName}?\n\nUna vez configurado el Servidor MCP de {appName}, automáticamente lee y almacena en caché todos los datos de documentación de API en tu máquina local. La IA puede entonces recuperar y utilizar estos datos sin problemas.\n\nSimplemente instruye a la IA sobre lo que te gustaría lograr con la documentación de API. Aquí hay algunos ejemplos:\n\n1. **Generar Código**: "Usa MCP para obtener la documentación de API y generar registros Java para el schema Product y schemas relacionados".\n2. **Actualizar DTOs**: "Basado en la documentación de API, agrega los nuevos campos al DTO Product".\n3. **Agregar Comentarios**: "Agrega comentarios para cada campo en la clase Product basado en la documentación de API".\n4. **Crear Código MVC**: "Genera todo el código MVC relacionado con el endpoint /users según la documentación de API".',

  'specialFile.menu.copy.label': 'Copiar Página',
  'specialFile.menu.copy.description': 'Copiar esta página como Markdown para LLMs',
  'specialFile.menu.markdown.label': 'Ver como Markdown',
  'specialFile.menu.markdown.description': 'Ver esta página como texto plano',
  'specialFile.menu.gpt.label': 'Abrir en {gptName}',
  'specialFile.menu.gpt.prompt': 'Lee desde {link} para que pueda hacer preguntas sobre ello.',
  'specialFile.menu.gpt.description': 'Hacer preguntas sobre esta página',
  'specialFile.menu.llms.label': 'LLMs.txt',
  'specialFile.menu.llms.description':
    'Proporcionar información para ayudar a los LLMs a usar el sitio completo de documentación de API',
  'specialFile.failToCopied':
    'Copia fallida, por favor agrega .md después de la URL de la página para ver el Markdown.',
  'docsSite.login.error': 'Error de inicio de sesión',
  'docsSite.login.error.detail':
    'El JWT devuelto por la página de inicio de sesión personalizada falló en la verificación de firma, por favor contacta al editor del documento para modificar la configuración.',

  'apiTest.debug.dataSource.error':
    'La versión web no soporta operaciones de base de datos en este momento, por favor descarga el {appName} de escritorio.',
  'apiTest.debug.execute.error':
    'La versión web aún no soporta llamadas a programas externos, por favor descarga el {appName} de escritorio.',
  'apiTest.debug.liveRequire.error':
    'La versión Web no soporta la introducción dinámica de bibliotecas externas actualmente, por favor descarga el {appName} de escritorio.',
  'customDomain.error.tip.canNotAccess':
    'El nombre de dominio actual solo se utiliza para la configuración CNAME y no se puede acceder directamente.',
} satisfies typeof EnType;
